{
    "v": "4.8.0",
    "meta": { "g": "LottieFiles AE ", "a": "", "k": "", "d": "", "tc": "" },
    "fr": 25,
    "ip": 0,
    "op": 75,
    "w": 500,
    "h": 500,
    "nm": "02-Check",
    "ddd": 0,
    "assets": [],
    "layers": [
        {
            "ddd": 0,
            "ind": 1,
            "ty": 3,
            "nm": "Main Stroke width-Color Ctrl",
            "parent": 11,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 0, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [0, 0, 0], "ix": 2 },
                "a": { "a": 0, "k": [50, 50, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "ef": [
                {
                    "ty": 5,
                    "nm": "Stroke width",
                    "np": 3,
                    "mn": "ADBE Slider Control",
                    "ix": 1,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 0,
                            "nm": "Slider",
                            "mn": "ADBE Slider Control-0001",
                            "ix": 1,
                            "v": { "a": 0, "k": 24, "ix": 1 }
                        }
                    ]
                }
            ],
            "ip": 0,
            "op": 75,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 2,
            "ty": 4,
            "nm": "Paper border 2",
            "parent": 9,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [0, 0, 0], "ix": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 13,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, -7.937],
                                                    [0, 0],
                                                    [-7.937, 0],
                                                    [0, 0],
                                                    [0, 7.937],
                                                    [0, 0],
                                                    [7.937, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [-7.937, 0],
                                                    [0, 0],
                                                    [0, 7.937],
                                                    [0, 0],
                                                    [7.937, 0],
                                                    [0, 0],
                                                    [0, -7.937],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-111.965, -136.869],
                                                    [-161.539, -136.869],
                                                    [-175.911, -122.497],
                                                    [-175.911, 162.134],
                                                    [-161.539, 176.506],
                                                    [37.962, 176.506],
                                                    [52.334, 162.134],
                                                    [52.334, -122.497],
                                                    [37.962, -136.869],
                                                    [-11.632, -136.869]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 16,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, -7.937],
                                                    [0, 0],
                                                    [-7.937, 0],
                                                    [0, 0],
                                                    [0, 7.937],
                                                    [0, 0],
                                                    [7.937, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [-7.937, 0],
                                                    [0, 0],
                                                    [0, 7.937],
                                                    [0, 0],
                                                    [7.937, 0],
                                                    [0, 0],
                                                    [0, -7.937],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-111.965, -136.869],
                                                    [-161.539, -136.869],
                                                    [-175.911, -122.497],
                                                    [-175.428, 191.134],
                                                    [-161.056, 205.505],
                                                    [38.445, 205.505],
                                                    [52.817, 191.134],
                                                    [52.334, -122.497],
                                                    [37.962, -136.869],
                                                    [-11.632, -136.869]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 26,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, -7.937],
                                                    [0, 0],
                                                    [-7.937, 0],
                                                    [0, 0],
                                                    [0, 7.937],
                                                    [0, 0],
                                                    [7.937, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [-7.937, 0],
                                                    [0, 0],
                                                    [0, 7.937],
                                                    [0, 0],
                                                    [7.937, 0],
                                                    [0, 0],
                                                    [0, -7.937],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-111.965, -136.869],
                                                    [-161.539, -136.869],
                                                    [-175.911, -122.497],
                                                    [-175.428, 191.134],
                                                    [-161.056, 205.505],
                                                    [38.445, 205.505],
                                                    [52.817, 191.134],
                                                    [52.334, -122.497],
                                                    [37.962, -136.869],
                                                    [-11.632, -136.869]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "t": 29,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, -7.937],
                                                    [0, 0],
                                                    [-7.937, 0],
                                                    [0, 0],
                                                    [0, 7.937],
                                                    [0, 0],
                                                    [7.937, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [-7.937, 0],
                                                    [0, 0],
                                                    [0, 7.937],
                                                    [0, 0],
                                                    [7.937, 0],
                                                    [0, 0],
                                                    [0, -7.937],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-111.965, -136.869],
                                                    [-161.539, -136.869],
                                                    [-175.911, -122.497],
                                                    [-175.911, 162.134],
                                                    [-161.539, 176.506],
                                                    [37.962, 176.506],
                                                    [52.334, 162.134],
                                                    [52.334, -122.497],
                                                    [37.962, -136.869],
                                                    [-11.632, -136.869]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width-Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 75,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 3,
            "ty": 4,
            "nm": "New info",
            "parent": 9,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [0, 0, 0], "ix": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [-53.289, -42.968],
                                        [9.024, -42.968]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width-Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 5",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [-133.045, 2.496],
                                        [9.024, 2.496]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width-Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 4",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [-53.289, 82.641],
                                        [11.894, 82.641]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width-Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 2",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 3,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [-133.045, 127.456],
                                        [9.024, 127.456]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width-Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 4,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [-132.145, -54.892],
                                        [-118.492, -42.539],
                                        [-91.036, -73.896]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0.157, 0.176, 0.212, 1],
                                "ix": 3
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width-Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 6",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 5,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [-132.145, 70.758],
                                        [-118.492, 83.111],
                                        [-91.036, 51.755]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0.157, 0.176, 0.212, 1],
                                "ix": 3
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width-Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 3",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 6,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "tm",
                    "s": { "a": 0, "k": 0, "ix": 1 },
                    "e": {
                        "a": 1,
                        "k": [
                            {
                                "i": { "x": [0.57], "y": [1] },
                                "o": { "x": [0.43], "y": [0] },
                                "t": 33,
                                "s": [0]
                            },
                            { "t": 67, "s": [100] }
                        ],
                        "ix": 2
                    },
                    "o": { "a": 0, "k": 0, "ix": 3 },
                    "m": 2,
                    "ix": 7,
                    "nm": "Trim Paths 1",
                    "mn": "ADBE Vector Filter - Trim",
                    "hd": false
                }
            ],
            "ip": 33,
            "op": 75,
            "st": -16,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 4,
            "ty": 4,
            "nm": "Paper mask 2",
            "parent": 9,
            "td": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [0, 0, 0], "ix": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 13,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, -7.937],
                                                    [0, 0],
                                                    [-7.937, 0],
                                                    [0, 0],
                                                    [0, 7.937],
                                                    [0, 0],
                                                    [7.937, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [-7.937, 0],
                                                    [0, 0],
                                                    [0, 7.937],
                                                    [0, 0],
                                                    [7.937, 0],
                                                    [0, 0],
                                                    [0, -7.937],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-111.965, -136.869],
                                                    [-161.539, -136.869],
                                                    [-175.911, -122.497],
                                                    [-175.911, 162.134],
                                                    [-161.539, 176.506],
                                                    [37.962, 176.506],
                                                    [52.334, 162.134],
                                                    [52.334, -122.497],
                                                    [37.962, -136.869],
                                                    [-11.632, -136.869]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 16,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, -7.937],
                                                    [0, 0],
                                                    [-7.937, 0],
                                                    [0, 0],
                                                    [0, 7.937],
                                                    [0, 0],
                                                    [7.937, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [-7.937, 0],
                                                    [0, 0],
                                                    [0, 7.937],
                                                    [0, 0],
                                                    [7.937, 0],
                                                    [0, 0],
                                                    [0, -7.937],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-111.965, -136.869],
                                                    [-161.539, -136.869],
                                                    [-175.911, -122.497],
                                                    [-175.428, 191.134],
                                                    [-161.056, 205.505],
                                                    [38.445, 205.505],
                                                    [52.817, 191.134],
                                                    [52.334, -122.497],
                                                    [37.962, -136.869],
                                                    [-11.632, -136.869]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 26,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, -7.937],
                                                    [0, 0],
                                                    [-7.937, 0],
                                                    [0, 0],
                                                    [0, 7.937],
                                                    [0, 0],
                                                    [7.937, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [-7.937, 0],
                                                    [0, 0],
                                                    [0, 7.937],
                                                    [0, 0],
                                                    [7.937, 0],
                                                    [0, 0],
                                                    [0, -7.937],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-111.965, -136.869],
                                                    [-161.539, -136.869],
                                                    [-175.911, -122.497],
                                                    [-175.428, 191.134],
                                                    [-161.056, 205.505],
                                                    [38.445, 205.505],
                                                    [52.817, 191.134],
                                                    [52.334, -122.497],
                                                    [37.962, -136.869],
                                                    [-11.632, -136.869]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 29,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, -7.937],
                                                    [0, 0],
                                                    [-7.937, 0],
                                                    [0, 0],
                                                    [0, 7.937],
                                                    [0, 0],
                                                    [7.937, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [-7.937, 0],
                                                    [0, 0],
                                                    [0, 7.937],
                                                    [0, 0],
                                                    [7.937, 0],
                                                    [0, 0],
                                                    [0, -7.937],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-21.086, -154.726],
                                                    [-107.764, -153.676],
                                                    [-161.539, -136.869],
                                                    [-175.911, -122.497],
                                                    [-175.911, 162.134],
                                                    [-161.539, 176.506],
                                                    [37.962, 176.506],
                                                    [52.334, 162.134],
                                                    [52.334, -122.497],
                                                    [37.962, -136.869]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "t": 36,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, -7.937],
                                                    [0, 0],
                                                    [-7.937, 0],
                                                    [0, 0],
                                                    [0, 7.937],
                                                    [0, 0],
                                                    [7.937, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [-7.937, 0],
                                                    [0, 0],
                                                    [0, 7.937],
                                                    [0, 0],
                                                    [7.937, 0],
                                                    [0, 0],
                                                    [0, -7.937],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-14.783, -148.424],
                                                    [-110.915, -148.424],
                                                    [-161.539, -136.869],
                                                    [-175.911, -122.497],
                                                    [-175.911, 162.134],
                                                    [-161.539, 176.506],
                                                    [37.962, 176.506],
                                                    [52.334, 162.134],
                                                    [52.334, -122.497],
                                                    [37.962, -136.869]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width-Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "fl",
                    "c": { "a": 0, "k": [1, 0, 0, 1], "ix": 4 },
                    "o": { "a": 0, "k": 100, "ix": 5 },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 75,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 5,
            "ty": 4,
            "nm": "2nd paper",
            "parent": 6,
            "tt": 2,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.833, "y": 0.833 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 13,
                            "s": [54, 0, 0],
                            "to": [0, 4.833, 0],
                            "ti": [0, -4.833, 0]
                        },
                        {
                            "i": { "x": 0.833, "y": 0.833 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 16,
                            "s": [54, 29, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.833, "y": 0.833 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 26,
                            "s": [54, 29, 0],
                            "to": [0, -4.833, 0],
                            "ti": [0, 4.833, 0]
                        },
                        {
                            "i": { "x": 0.833, "y": 0.833 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 29,
                            "s": [54, 0, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.833, "y": 0.833 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 32,
                            "s": [54, 0, 0],
                            "to": [-8.929, 0, 0],
                            "ti": [8.929, 0, 0]
                        },
                        { "t": 40, "s": [0.429, 0, 0] }
                    ],
                    "ix": 2
                },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 6,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, -7.937],
                                                    [0, 0],
                                                    [-7.937, 0],
                                                    [0, 0],
                                                    [0, 7.937],
                                                    [0, 0],
                                                    [7.937, 0]
                                                ],
                                                "o": [
                                                    [-7.937, 0],
                                                    [0, 0],
                                                    [0, 7.937],
                                                    [0, 0],
                                                    [7.937, 0],
                                                    [0, 0],
                                                    [0, -7.937],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-161.489, 144.33],
                                                    [-175.861, 158.702],
                                                    [-175.911, 162.134],
                                                    [-161.539, 176.506],
                                                    [-165.441, 176.185],
                                                    [-151.069, 161.813],
                                                    [-151.019, 158.381],
                                                    [-165.391, 144.009]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 12,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, -7.937],
                                                    [0, 0],
                                                    [-7.937, 0],
                                                    [0, 0],
                                                    [0, 7.937],
                                                    [0, 0],
                                                    [7.937, 0]
                                                ],
                                                "o": [
                                                    [-7.937, 0],
                                                    [0, 0],
                                                    [0, 7.937],
                                                    [0, 0],
                                                    [7.937, 0],
                                                    [0, 0],
                                                    [0, -7.937],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-161.769, 151.624],
                                                    [-176.141, 165.996],
                                                    [-175.911, 162.134],
                                                    [-161.539, 176.506],
                                                    [37.962, 176.506],
                                                    [52.334, 162.134],
                                                    [52.104, 165.996],
                                                    [37.733, 151.624]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "t": 26,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, -7.937],
                                                    [0, 0],
                                                    [-7.937, 0],
                                                    [0, 0],
                                                    [0, 7.937],
                                                    [0, 0],
                                                    [7.937, 0]
                                                ],
                                                "o": [
                                                    [-7.937, 0],
                                                    [0, 0],
                                                    [0, 7.937],
                                                    [0, 0],
                                                    [7.937, 0],
                                                    [0, 0],
                                                    [0, -7.937],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-161.539, -136.869],
                                                    [-175.911, -122.497],
                                                    [-175.911, 162.134],
                                                    [-161.539, 176.506],
                                                    [37.962, 176.506],
                                                    [52.334, 162.134],
                                                    [52.334, -122.497],
                                                    [37.962, -136.869]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width-Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 7",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": -8,
            "op": 49,
            "st": -19,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 6,
            "ty": 3,
            "nm": "Top part guide",
            "parent": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": [0.7], "y": [1] },
                            "o": { "x": [0.3], "y": [0] },
                            "t": 0.333,
                            "s": [0]
                        },
                        {
                            "i": { "x": [0.7], "y": [1] },
                            "o": { "x": [0.3], "y": [0] },
                            "t": 8.25,
                            "s": [4]
                        },
                        {
                            "i": { "x": [0.659], "y": [0.77] },
                            "o": { "x": [0.297], "y": [0] },
                            "t": 13,
                            "s": [-7]
                        },
                        {
                            "i": { "x": [0.694], "y": [1] },
                            "o": { "x": [0.352], "y": [-1.07] },
                            "t": 19,
                            "s": [2]
                        },
                        { "t": 25, "s": [0] }
                    ],
                    "ix": 10
                },
                "p": { "a": 0, "k": [-11.788, -96.577, 0], "ix": 2 },
                "a": { "a": 0, "k": [-61.788, -146.577, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "ip": 0,
            "op": 75,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 7,
            "ty": 4,
            "nm": "Paper mask 3",
            "parent": 2,
            "td": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [0, 0, 0], "ix": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 13,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, -7.937],
                                                    [0, 0],
                                                    [-7.937, 0],
                                                    [0, 0],
                                                    [0, 7.937],
                                                    [0, 0],
                                                    [7.937, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [-7.937, 0],
                                                    [0, 0],
                                                    [0, 7.937],
                                                    [0, 0],
                                                    [7.937, 0],
                                                    [0, 0],
                                                    [0, -7.937],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-111.965, -136.869],
                                                    [-161.539, -136.869],
                                                    [-175.911, -122.497],
                                                    [-175.911, 162.134],
                                                    [-161.539, 176.506],
                                                    [37.962, 176.506],
                                                    [52.334, 162.134],
                                                    [52.334, -122.497],
                                                    [37.962, -136.869],
                                                    [-11.632, -136.869],
                                                    [-10.961, -116.775],
                                                    [-111.303, -114.362],
                                                    [-111.833, -136.869],
                                                    [-111.918, -136.869],
                                                    [-111.932, -136.869]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 16,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, -7.937],
                                                    [0, 0],
                                                    [-7.937, 0],
                                                    [0, 0],
                                                    [0, 7.937],
                                                    [0, 0],
                                                    [7.937, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [-7.937, 0],
                                                    [0, 0],
                                                    [0, 7.937],
                                                    [0, 0],
                                                    [7.937, 0],
                                                    [0, 0],
                                                    [0, -7.937],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-111.965, -136.869],
                                                    [-161.539, -136.869],
                                                    [-175.911, -122.497],
                                                    [-175.428, 191.134],
                                                    [-161.056, 205.505],
                                                    [38.445, 205.505],
                                                    [52.817, 191.134],
                                                    [52.334, -122.497],
                                                    [37.962, -136.869],
                                                    [-11.632, -136.869],
                                                    [-15.357, -116.134],
                                                    [-110.19, -116.18],
                                                    [-111.833, -136.869],
                                                    [-111.918, -136.869],
                                                    [-111.932, -136.869]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 26,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, -7.937],
                                                    [0, 0],
                                                    [-7.937, 0],
                                                    [0, 0],
                                                    [0, 7.937],
                                                    [0, 0],
                                                    [7.937, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [-7.937, 0],
                                                    [0, 0],
                                                    [0, 7.937],
                                                    [0, 0],
                                                    [7.937, 0],
                                                    [0, 0],
                                                    [0, -7.937],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-111.965, -136.869],
                                                    [-161.539, -136.869],
                                                    [-175.911, -122.497],
                                                    [-175.428, 191.134],
                                                    [-161.056, 205.505],
                                                    [38.445, 205.505],
                                                    [52.817, 191.134],
                                                    [52.334, -122.497],
                                                    [37.962, -136.869],
                                                    [-11.632, -136.869],
                                                    [-37.774, -136.869],
                                                    [-94.555, -136.869],
                                                    [-111.833, -136.869],
                                                    [-111.918, -136.869],
                                                    [-111.932, -136.869]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "t": 29,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, -7.937],
                                                    [0, 0],
                                                    [-7.937, 0],
                                                    [0, 0],
                                                    [0, 7.937],
                                                    [0, 0],
                                                    [7.937, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [-7.937, 0],
                                                    [0, 0],
                                                    [0, 7.937],
                                                    [0, 0],
                                                    [7.937, 0],
                                                    [0, 0],
                                                    [0, -7.937],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-111.965, -136.869],
                                                    [-161.539, -136.869],
                                                    [-175.911, -122.497],
                                                    [-175.911, 162.134],
                                                    [-161.539, 176.506],
                                                    [37.962, 176.506],
                                                    [52.334, 162.134],
                                                    [52.334, -122.497],
                                                    [37.962, -136.869],
                                                    [-11.632, -136.869],
                                                    [-37.774, -136.869],
                                                    [-94.555, -136.869],
                                                    [-111.833, -136.869],
                                                    [-111.918, -136.869],
                                                    [-111.932, -136.869]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width-Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "fl",
                    "c": { "a": 0, "k": [1, 0, 0, 1], "ix": 4 },
                    "o": { "a": 0, "k": 100, "ix": 5 },
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 75,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 8,
            "ty": 4,
            "nm": "Main paper",
            "parent": 9,
            "tt": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.45, "y": 1 },
                            "o": { "x": 0.55, "y": 0 },
                            "t": 11,
                            "s": [0, 0, 0],
                            "to": [0, 60.833, 0],
                            "ti": [0, -60.833, 0]
                        },
                        { "t": 33, "s": [0, 365, 0] }
                    ],
                    "ix": 2
                },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [-133.045, 127.456],
                                        [9.024, 127.456]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width-Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [-53.289, 82.641],
                                        [11.894, 82.641]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width-Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 2",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [-132.145, 70.758],
                                        [-118.492, 83.111],
                                        [-91.036, 51.755]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0.157, 0.176, 0.212, 1],
                                "ix": 3
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width-Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 3",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 3,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [-133.045, 2.496],
                                        [9.024, 2.496]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width-Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 4",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 4,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [-53.289, -42.968],
                                        [9.024, -42.968]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width-Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 5",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 5,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [-132.145, -54.892],
                                        [-118.492, -42.539],
                                        [-91.036, -73.896]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0.157, 0.176, 0.212, 1],
                                "ix": 3
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width-Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 6",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 6,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, -7.937],
                                        [0, 0],
                                        [-7.937, 0],
                                        [0, 0],
                                        [0, 7.937],
                                        [0, 0],
                                        [7.937, 0]
                                    ],
                                    "o": [
                                        [-7.937, 0],
                                        [0, 0],
                                        [0, 7.937],
                                        [0, 0],
                                        [7.937, 0],
                                        [0, 0],
                                        [0, -7.937],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [-161.539, -136.869],
                                        [-175.911, -122.497],
                                        [-175.911, 162.134],
                                        [-161.539, 176.506],
                                        [37.962, 176.506],
                                        [52.334, 162.134],
                                        [52.334, -122.497],
                                        [37.962, -136.869]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width-Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 7",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 7,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 75,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 9,
            "ty": 4,
            "nm": "Top part",
            "parent": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": [0.7], "y": [1] },
                            "o": { "x": [0.3], "y": [0] },
                            "t": 0.333,
                            "s": [0]
                        },
                        {
                            "i": { "x": [0.7], "y": [1] },
                            "o": { "x": [0.3], "y": [0] },
                            "t": 8.25,
                            "s": [4]
                        },
                        {
                            "i": { "x": [0.659], "y": [0.77] },
                            "o": { "x": [0.297], "y": [0] },
                            "t": 13,
                            "s": [-7]
                        },
                        {
                            "i": { "x": [0.694], "y": [1] },
                            "o": { "x": [0.352], "y": [-1.07] },
                            "t": 19,
                            "s": [2]
                        },
                        { "t": 25, "s": [0] }
                    ],
                    "ix": 10
                },
                "p": { "a": 0, "k": [-11.788, -96.577, 0], "ix": 2 },
                "a": { "a": 0, "k": [-61.788, -146.577, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [13.482, 0],
                                        [0.27, -13.417],
                                        [0, 0],
                                        [0, -2.585],
                                        [0, 0],
                                        [-3.372, 0],
                                        [0, 0],
                                        [0, 3.372],
                                        [0, 0],
                                        [2.661, 0]
                                    ],
                                    "o": [
                                        [-0.27, -13.417],
                                        [-13.482, 0],
                                        [0, 0],
                                        [-2.585, 0],
                                        [0, 0],
                                        [0, 3.372],
                                        [0, 0],
                                        [3.372, 0],
                                        [0, 0],
                                        [0, -2.661],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [-37.084, -151.468],
                                        [-61.788, -175.68],
                                        [-86.493, -151.468],
                                        [-107.298, -151.468],
                                        [-111.979, -146.787],
                                        [-111.979, -123.579],
                                        [-105.873, -117.474],
                                        [-17.703, -117.474],
                                        [-11.598, -123.579],
                                        [-11.598, -146.649],
                                        [-16.416, -151.468]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width-Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 75,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 10,
            "ty": 4,
            "nm": "Back paper",
            "parent": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [50, 50, 0], "ix": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.7, "y": 1 },
                                        "o": { "x": 0.3, "y": 0 },
                                        "t": 0,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 8.099],
                                                    [0, 0],
                                                    [8.712, 0],
                                                    [0, 0],
                                                    [1.807, -2.121]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [7.859, -0.899],
                                                    [0, 0],
                                                    [0, -8.712],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [52.334, 157.773],
                                                    [120.942, 157.773],
                                                    [162.255, 157.773],
                                                    [162.224, 157.661],
                                                    [176.189, 141.998],
                                                    [176.189, -160.571],
                                                    [160.414, -176.346],
                                                    [-48.236, -176.346],
                                                    [-53.371, -174.209]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.3, "y": 0 },
                                        "t": 8,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 8.099],
                                                    [0, 0],
                                                    [8.712, 0],
                                                    [0, 0],
                                                    [1.807, -2.121]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [7.859, -0.899],
                                                    [0, 0],
                                                    [0, -8.712],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [36.334, 157.546],
                                                    [120.942, 157.773],
                                                    [162.255, 157.773],
                                                    [162.224, 157.661],
                                                    [176.189, 141.998],
                                                    [176.189, -160.571],
                                                    [160.414, -176.346],
                                                    [-48.236, -176.346],
                                                    [-53.371, -174.209]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 10,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 8.099],
                                                    [0, 0],
                                                    [8.712, 0],
                                                    [0, 0],
                                                    [1.807, -2.121]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [7.859, -0.899],
                                                    [0, 0],
                                                    [0, -8.712],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [53.962, 157.388],
                                                    [125.715, 157.852],
                                                    [162.255, 157.773],
                                                    [162.224, 157.661],
                                                    [176.189, 141.998],
                                                    [176.189, -160.571],
                                                    [160.414, -176.346],
                                                    [-48.236, -176.346],
                                                    [-53.371, -174.209]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.7, "y": 1 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 12,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 8.099],
                                                    [0, 0],
                                                    [8.712, 0],
                                                    [0, 0],
                                                    [1.807, -2.121]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [7.859, -0.899],
                                                    [0, 0],
                                                    [0, -8.712],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [135.585, 157.36],
                                                    [133.547, 157.983],
                                                    [162.255, 157.773],
                                                    [162.224, 157.661],
                                                    [176.189, 141.998],
                                                    [176.189, -160.571],
                                                    [160.414, -176.346],
                                                    [-48.236, -176.346],
                                                    [-53.371, -174.209]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.3, "y": 0 },
                                        "t": 13,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 8.099],
                                                    [0, 0],
                                                    [8.712, 0],
                                                    [0, 0],
                                                    [1.807, -2.121]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [7.859, -0.899],
                                                    [0, 0],
                                                    [0, -8.712],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [128.2, 156.726],
                                                    [148.253, 157.88],
                                                    [162.255, 157.773],
                                                    [162.224, 157.661],
                                                    [176.189, 141.998],
                                                    [176.189, -160.571],
                                                    [160.414, -176.346],
                                                    [-48.236, -176.346],
                                                    [-53.371, -174.209]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 14,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 8.099],
                                                    [0, 0],
                                                    [8.712, 0],
                                                    [0, 0],
                                                    [1.807, -2.121]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [7.859, -0.899],
                                                    [0, 0],
                                                    [0, -8.712],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [140.81, 156.756],
                                                    [140.9, 157.983],
                                                    [162.255, 157.773],
                                                    [162.224, 157.661],
                                                    [176.189, 141.998],
                                                    [176.189, -160.571],
                                                    [160.414, -176.346],
                                                    [-48.236, -176.346],
                                                    [-53.371, -174.209]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.7, "y": 1 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 15,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 8.099],
                                                    [0, 0],
                                                    [8.712, 0],
                                                    [0, 0],
                                                    [1.807, -2.121]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [7.859, -0.899],
                                                    [0, 0],
                                                    [0, -8.712],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [136.223, 157.135],
                                                    [141.224, 158.299],
                                                    [162.255, 157.773],
                                                    [162.224, 157.661],
                                                    [176.189, 141.998],
                                                    [176.189, -160.571],
                                                    [160.414, -176.346],
                                                    [-48.236, -176.346],
                                                    [-53.371, -174.209]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.3, "y": 0 },
                                        "t": 19,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 8.099],
                                                    [0, 0],
                                                    [8.712, 0],
                                                    [0, 0],
                                                    [1.807, -2.121]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [7.859, -0.899],
                                                    [0, 0],
                                                    [0, -8.712],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [100.956, 156.802],
                                                    [120.942, 157.773],
                                                    [162.255, 157.773],
                                                    [162.224, 157.661],
                                                    [176.189, 141.998],
                                                    [176.189, -160.571],
                                                    [160.414, -176.346],
                                                    [-48.236, -176.346],
                                                    [-53.371, -174.209]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.7, "y": 1 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 20,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 8.099],
                                                    [0, 0],
                                                    [8.712, 0],
                                                    [0, 0],
                                                    [1.807, -2.121]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [7.859, -0.899],
                                                    [0, 0],
                                                    [0, -8.712],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [95.13, 157.151],
                                                    [114.639, 158.092],
                                                    [162.255, 157.773],
                                                    [162.224, 157.661],
                                                    [176.189, 141.998],
                                                    [176.189, -160.571],
                                                    [160.414, -176.346],
                                                    [-48.236, -176.346],
                                                    [-53.371, -174.209]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 1 },
                                        "o": { "x": 0.3, "y": 0 },
                                        "t": 25,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 8.099],
                                                    [0, 0],
                                                    [8.712, 0],
                                                    [0, 0],
                                                    [1.807, -2.121]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [7.859, -0.899],
                                                    [0, 0],
                                                    [0, -8.712],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [106.754, 157.167],
                                                    [120.942, 157.773],
                                                    [162.255, 157.773],
                                                    [162.224, 157.661],
                                                    [176.189, 141.998],
                                                    [176.189, -160.571],
                                                    [160.414, -176.346],
                                                    [-48.236, -176.346],
                                                    [-53.371, -174.209]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 1 },
                                        "o": { "x": 0.167, "y": 0 },
                                        "t": 32,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 8.099],
                                                    [0, 0],
                                                    [8.712, 0],
                                                    [0, 0],
                                                    [1.807, -2.121]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [7.859, -0.899],
                                                    [0, 0],
                                                    [0, -8.712],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [106.754, 157.167],
                                                    [120.942, 157.773],
                                                    [162.255, 157.773],
                                                    [162.224, 157.661],
                                                    [176.189, 141.998],
                                                    [176.189, -160.571],
                                                    [160.414, -176.346],
                                                    [-48.236, -176.346],
                                                    [-53.371, -174.209]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "t": 40,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 8.099],
                                                    [0, 0],
                                                    [8.712, 0],
                                                    [0, 0],
                                                    [1.807, -2.121]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [7.859, -0.899],
                                                    [0, 0],
                                                    [0, -8.712],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [55.284, 156.77],
                                                    [120.942, 157.773],
                                                    [162.255, 157.773],
                                                    [162.224, 157.661],
                                                    [176.189, 141.998],
                                                    [176.189, -160.571],
                                                    [160.414, -176.346],
                                                    [-48.236, -176.346],
                                                    [-53.371, -174.209]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width-Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 75,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 11,
            "ty": 3,
            "nm": "Zero |  Stroke width-Color Ctrl",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 0, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [250, 250, 0], "ix": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "ip": 0,
            "op": 75,
            "st": 0,
            "bm": 0
        }
    ],
    "markers": []
}
